import AiAssessmentScaleView from "@features/tools/view/ai-assessment-scale";

const AiAssessmentScale = () => {
  return <AiAssessmentScaleView />;
};

export default AiAssessmentScale;
